// extracted by mini-css-extract-plugin
export default {"Flash":"BlameBanners-module__Flash--uicsZ","Box":"BlameBanners-module__Box--m11g9"};